module.exports = __webpack_public_path__ + "img/about_en.4ea8586.png";